import React from "react";
import _ from "lodash";
import Close from "../../../../../Icons/Close";
import imgUrlAvatar from "../../../../../styles/img/enfant-avatar.jpg";
import Activite from "./les-tabs/Activite";
import Absence from "./les-tabs/Absence";
import Arrivee from "./les-tabs/Arrivee";
import Message from "./les-tabs/Message";
import Petitcoin from "./les-tabs/Petitcoin";
import Repas from "./les-tabs/Repas";
import Sieste from "./les-tabs/Sieste";
import Sante from "./les-tabs/Sante";
import Empty from "./les-tabs/Empty";
import Depart from "./les-tabs/Depart";
import { fadeIn, fadeOut } from "react-animations";
import Radium, { StyleRoot } from "radium";
function jsUpperCaseFirst(string) {
  return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
const divStyleAvatar = {
  background: "url(" + imgUrlAvatar + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",
};

const styles = {
  bounce: {
    animation: "x 0.5s",
    animationName: Radium.keyframes(fadeIn, "fadeIn"),
    background: "rgba(0, 76, 197, 0.7)",
  },
  bounce2: {
    animation: "x 0.5s",
    animationName: Radium.keyframes(fadeOut, "fadeOut"),
    background: "rgba(0, 76, 197, 0.7)",
  },
};

class ModalEnfant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabActive: this.props.tabActive || "empty-tab",
      readySubmit: false,
      kidItem: {},
      dataUpdate: {},
      styleFadeIn: true,
    };

    this.handleTab = this.handleTab.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleStyle = this.handleStyle.bind(this);
    this.handleReadySubmit = this.handleReadySubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.activeArrivee = this.activeArrivee.bind(this);
    this.activeDepart = this.activeDepart.bind(this);
    this.activeMixTab = this.activeMixTab.bind(this);
    this.activeAbsence = this.activeAbsence.bind(this);
    this.activeSieste = this.activeSieste.bind(this);
    this.activePetitcoin = this.activePetitcoin.bind(this);
    this.activeSante = this.activeSante.bind(this);
    this.activeActivite = this.activeActivite.bind(this);
    this.activeMessage = this.activeMessage.bind(this);
    this.activeRepas = this.activeRepas.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.switchTabs = this.switchTabs.bind(this);
  }

  componentDidMount() {
    if (this.props.submitMulti && !_.isEmpty(this.props.dataMulti)) {
      this.setState({ tabActive: this.props.dataMulti.tabActive });
    }
    if (this.props.isUpdate && !_.isEmpty(this.props.tabToUpdate)) {
      this.setState({ tabActive: this.props.tabToUpdate });
    }
    if (this.props.onlyView && !_.isEmpty(this.props.tabToView)) {
      this.setState({ tabActive: this.props.tabToView });
    }
  }
  switchTabs(tab, kidItem) {
    switch (tab) {
      case "arrivee-tab":
        return !_.isEmpty(this.props.kidItem) &&
          this.props.kidItem.agenda.statutDetails.statut !== "PRESENT" &&
          !this.props.isUpdate ? (
          <Arrivee
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            arriveeData={this.props.modals.arrivee.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        ) : !_.isEmpty(this.props.kidItem) &&
          (this.props.isUpdate || this.props.onlyView) ? (
          <Arrivee
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            arriveeData={this.props.modals.arrivee.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        ) : (
          <Depart
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            departData={this.props.modals.depart.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        );

      case "absence-tab":
        return (
          <Absence
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            handleReadySubmit={this.handleReadySubmit}
            handleSubmit={this.handleSubmit}
            handleClose={this.props.handleClose}
            readySubmit={this.state.readySubmit}
            absenceData={this.props.modals.absence.data}
            isUpdate={this.props.isUpdate}
            objAbsence={this.props.objAbsence}
            dateStartEnd={this.props.dateStartEnd}
          />
        );
      case "sieste-tab":
        return (
          <Sieste
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            dataMulti={this.props.dataMulti}
            readySubmit={this.state.readySubmit}
            submitMulti={this.props.submitMulti}
            handleReadySubmit={this.handleReadySubmit}
            handleSubmit={this.handleSubmit}
            siesteData={this.props.modals.sieste.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        );
      case "repas-tab":
        return (
          <Repas
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            dataMulti={this.props.dataMulti}
            readySubmit={this.state.readySubmit}
            submitMulti={this.props.submitMulti}
            handleReadySubmit={this.handleReadySubmit}
            handleSubmit={this.handleSubmit}
            repasData={this.props.modals.repas.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        );
      case "petitcoin-tab":
        return (
          <Petitcoin
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            handleReadySubmit={this.handleReadySubmit}
            handleSubmit={this.handleSubmit}
            readySubmit={this.state.readySubmit}
            petitcoinData={this.props.modals.petitcoin.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        );
      case "sante-tab":
        return (
          <Sante
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            handleReadySubmit={this.handleReadySubmit}
            handleSubmit={this.handleSubmit}
            readySubmit={this.state.readySubmit}
            santeData={this.props.modals.sante.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        );
      case "activite-tab":
        return (
          <Activite
            dataMulti={this.props.dataMulti}
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            submitMulti={this.props.submitMulti}
            handleReadySubmit={this.handleReadySubmit}
            handleSubmit={this.handleSubmit}
            readySubmit={this.state.readySubmit}
            activiteData={this.props.modals.activite.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        );
      case "message-tab":
        return (
          <Message
            dataMulti={this.props.dataMulti}
            kidItem={kidItem}
            submitMulti={this.props.submitMulti}
            handleReadySubmit={this.handleReadySubmit}
            handleSubmit={this.handleSubmit}
            readySubmit={this.state.readySubmit}
            messageData={this.props.modals.message.data}
            isUpdate={this.props.isUpdate}
          />
        );
      case "empty-tab":
        return <Empty />;
      case "depart-tab":
        return (
          <Depart
            kidItem={kidItem}
            idEvent={this.props.idEvent}
            handleReadySubmit={this.handleReadySubmit}
            readySubmit={this.state.readySubmit}
            handleSubmit={this.handleSubmit}
            departData={this.props.modals.depart.data}
            isUpdate={this.props.isUpdate}
            onlyView={this.props.onlyView}
          />
        );
      default:
        return <Empty />;
    }
  }

  toggle() {
    this.props.toggle();
  }

  handleClose() {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.handleClose();
    }, 500);
  }

  componentWillUnmount() {
    this.setState({
      tabActive: "empty-tab",
      readySubmit: false,
      kidItem: {},
    });
  }

  handleReadySubmit() {
    if (this.state.readySubmit === false) {
      this.setState({ readySubmit: true });
    } else {
      this.setState({ readySubmit: false });
    }
  }

  handleSubmit() {}

  handleStyle() {
    return this.state.readySubmit
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }

  handleTab(string) {
    this.setState({ tabActive: string });
    this.props.stopUpdate();
    this.props.stopViewing();
  }
  componentWillUnmount() {
    this.props.stopUpdate();
  }

  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  activeMixTab() {
    let result =
      this.activeArrivee("arrivee-tab") + " " + this.activeDepart("depart-tab");
    return result.split(" ").includes("active")
      ? "active"
      : result.split(" ").includes("disabled")
      ?"disabled"
      : "";
  }
  activeArrivee(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activeDepart(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activeAbsence(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activeSieste(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : !_.isEmpty(this.props.kidItem) &&
        this.state.tabActive !== string &&
        this.props.kidItem.agenda.statutDetails.statut !== "PRESENT"
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activeRepas(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : !_.isEmpty(this.props.kidItem) &&
        this.state.tabActive !== string &&
        this.props.kidItem.agenda.statutDetails.statut !== "PRESENT"
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activePetitcoin(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : !_.isEmpty(this.props.kidItem) &&
        this.state.tabActive !== string &&
        this.props.kidItem.agenda.statutDetails.statut !== "PRESENT"
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activeSante(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : !_.isEmpty(this.props.kidItem) &&
        this.state.tabActive !== string &&
        this.props.kidItem.agenda.statutDetails.statut !== "PRESENT"
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activeActivite(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : !_.isEmpty(this.props.kidItem) &&
        this.state.tabActive !== string &&
        this.props.kidItem.agenda.statutDetails.statut !== "PRESENT"
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }
  activeMessage(string) {
    return this.state.tabActive !== string &&
      (this.props.isUpdate || this.props.onlyView)
      ? "disabled"
      : this.state.tabActive !== string && this.props.submitMulti
      ? "disabled"
      : this.state.tabActive === string
      ? "active"
      : "";
  }

  render() {
    const { isOpen, kidItem } = this.props;
    {
      return isOpen ? (
        <StyleRoot>
          <div
            className="modal show modal-skin modal-large modal-childunit"
            style={
              this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
            }
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header" style={divStyleAvatar}>
                  {!_.isEmpty(this.props.dataMulti) &&
                  this.props.submitMulti ? (
                    <h5>{`Que souhaitez-vous saisir pour ${this.props.dataMulti.presentNames.join()} ?`}</h5>
                  ) : !_.isEmpty(kidItem) ? (
                    <h5>
                      Que souhaitez-vous saisir pour{" "}
                      {kidItem.prenom +
                        " " +
                        jsUpperCaseFirst(kidItem.nom) +
                        "."}{" "}
                      ?
                    </h5>
                  ) : (
                    <h5>Que souhaitez-vous saisir pour cet enfant ?</h5>
                  )}
                  <button
                    onClick={this.handleClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <Close className="img-fluid" alt="" />
                  </button>
                </div>
                <div className="modal-body">
                  <ul className="nav nav-tabs choices-elts d-flex align-items-center justify-content-between">
                    <li className="nav-item">
                      <a
                        className={`nav-link  choice arrivee ${this.activeMixTab()}`}
                        id="arrivee-tab"
                        onClick={() => this.handleTab("arrivee-tab")}
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        <span>Arrivée Sortie</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link choice absence ${this.activeAbsence(
                          "absence-tab"
                        )}`}
                        id="absence-tab"
                        onClick={() => this.handleTab("absence-tab")}
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        <span>Absence</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link choice sieste ${this.activeSieste(
                          "sieste-tab"
                        )}`}
                        id="sieste-tab"
                        onClick={() => this.handleTab("sieste-tab")}
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        <span>Sieste</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link choice repas ${this.activeRepas(
                          "repas-tab"
                        )}`}
                        id="repas-tab"
                        onClick={() => this.handleTab("repas-tab")}
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        <span>Repas</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link choice petitcoin ${this.activePetitcoin(
                          "petitcoin-tab"
                        )}`}
                        id="petitcoin-tab"
                        onClick={() => this.handleTab("petitcoin-tab")}
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        <span>Petit coin</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link choice sante ${this.activeSante(
                          "sante-tab"
                        )}`}
                        id="sante-tab"
                        onClick={() => this.handleTab("sante-tab")}
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        <span>Santé</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link choice activite ${this.activeActivite(
                          "activite-tab"
                        )}`}
                        id="activite-tab"
                        onClick={() => this.handleTab("activite-tab")}
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        <span>Activité</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link choice message ${this.activeMessage(
                          "message-tab"
                        )}`}
                        id="message-tab"
                        onClick={() => this.handleTab("message-tab")}
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        <span>Message</span>
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    {this.switchTabs(this.state.tabActive, kidItem)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </StyleRoot>
      ) : (
        ""
      );
    }
  }
}

ModalEnfant.propTypes = {};
export default ModalEnfant;
